import { useQuery } from "@apollo/client/react";
import { Box, DateRange } from "@nulogy/components";
import LaborChart from "components/charts/LaborChart";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import { GetShiftInstanceByRange } from "hooks/apollo/shiftInstance/shiftInstance.gql";
import EventTypes from "hooks/apollo/usageData/EventTypes";
import useTrackUsage from "hooks/apollo/usageData/useTrackUsage";
import useComponentDidMount from "hooks/useComponentDidMount";
import useTimeZone from "hooks/useTimeZone";
import React, { useState } from "react";
import DateTime from "utils/DateTime";

export default function LaborSummary() {
  const trackUsage = useTrackUsage();
  useComponentDidMount(() => trackUsage(EventTypes.LABOR_SUMMARY));

  const [scheduledStart, setScheduledStart] = useState(new Date());
  const [scheduledEnd, setScheduledEnd] = useState(DateTime.timeFromNow(13, "days"));

  const { overrideToSiteTimeZone } = useTimeZone();

  const { data, refetch: refetchShiftInstances } = useQuery(GetShiftInstanceByRange, {
    variables: {
      scheduledEnd: overrideToSiteTimeZone(DateTime.endOfDay(scheduledEnd).toDate()),
      scheduledStart: overrideToSiteTimeZone(DateTime.startOfDay(scheduledStart).toDate()),
    },
  });

  let laborData = [];

  if (data) {
    laborData = data.shiftInstances.map((shiftInstance) => ({
      "Max labor": shiftInstance.maxLabor,
      name: name(shiftInstance),
      "Starting labor": shiftInstance.startingLabor,
    }));
  }

  return (
    <PageWithBreadcrumbs title="Labor summary">
      <Box marginBottom="x4">
        <DateRange
          defaultEndDate={scheduledEnd}
          defaultStartDate={scheduledStart}
          labelProps={{ labelText: "Date range" }}
          onRangeChange={({ startDate, endDate }) => {
            setScheduledStart(startDate);
            setScheduledEnd(endDate);
            refetchShiftInstances({
              scheduledEnd: overrideToSiteTimeZone(DateTime.endOfDay(endDate).toDate()),
              scheduledStart: overrideToSiteTimeZone(DateTime.startOfDay(startDate).toDate()),
            });
          }}
        />
      </Box>
      <LaborChart data={laborData} />
    </PageWithBreadcrumbs>
  );
}

function name(shiftInstance) {
  const date = DateTime.format(shiftInstance.scheduledStart, "MMM DD");

  return `${date} ${shiftInstance.name}`;
}
